import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import OperatorPilotReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/operator-pilot.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(OperatorPilotReducer, defaultState, asyncActions);
};

type IOperatorPilotContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const OperatorPilotContext = createContext<Partial<IOperatorPilotContext>>({
  state: defaultState,
}) as React.Context<IOperatorPilotContext>;

const OperatorPilotProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <OperatorPilotContext.Provider value={{ ...reducer }}>
      {children}
    </OperatorPilotContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useOperatorPilotContext = () => useContext(OperatorPilotContext);

export type IUseOperatorPilotContext = ReturnType<
  typeof useOperatorPilotContext
>;

export { OperatorPilotContext, OperatorPilotProvider };
